import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { RegionDto } from '../lib/types';

export function useRegions() {
  return useQuery({
    queryKey: ['regions'],
    queryFn: () => apiClient.get<RegionDto[]>('/api/regions'),
  });
}
